/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PineconeInputs */

const en_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinecone`)
};

const ar_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinecone`)
};

const bn_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinecone`)
};

const de_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tannenzapfen`)
};

const es_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piña`)
};

const fr_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomme de pin`)
};

const pt_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinha`)
};

const zh_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`松果`)
};

const tr_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çam kozalağı`)
};

const ru_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сосновая шишка`)
};

const pl_svchip_pinecone = /** @type {(inputs: Svchip_PineconeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szyszka`)
};

/**
* | output |
* | --- |
* | "Pinecone" |
*
* @param {Svchip_PineconeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_pinecone = /** @type {((inputs?: Svchip_PineconeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PineconeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_pinecone(inputs)
	if (locale === "bn") return bn_svchip_pinecone(inputs)
	if (locale === "de") return de_svchip_pinecone(inputs)
	if (locale === "es") return es_svchip_pinecone(inputs)
	if (locale === "fr") return fr_svchip_pinecone(inputs)
	if (locale === "pt") return pt_svchip_pinecone(inputs)
	if (locale === "zh") return zh_svchip_pinecone(inputs)
	if (locale === "tr") return tr_svchip_pinecone(inputs)
	if (locale === "ru") return ru_svchip_pinecone(inputs)
	if (locale === "pl") return pl_svchip_pinecone(inputs)
	return en_svchip_pinecone(inputs)
});